// Iberia extent + the vector source-layer contract the PaperMap style renders.
// Names follow OpenMapTiles convention so a full planetiler extract is a file swap.
export const IBERIA_BBOX: [number, number, number, number] = [-10.0, 35.5, 4.0, 44.2];
// Region-neutral default view: the browse-only map opens on the loaded basemap's OWN
// center (read from its PMTiles header at runtime — see map-view.ts), so it follows
// whatever extract you serve (Iberia, Europe, US, …). This constant is only the
// last-resort fallback if that header can't be read; [lng, lat], MapLibre order.
export const DEFAULT_MAP_CENTER: [number, number] = [-3.7, 40.0];

/** Default home seed — central Lisbon (Praça do Comércio area). [lng, lat], MapLibre order. */
export const LISBOA_CENTER: [number, number] = [-9.1393, 38.7223];

/** Bounds [west, south, east, north] of the served basemap extract — used to warn
 *  when a home/location falls outside the mapped region. Defaults to continental
 *  Europe (the tiles-initialize.sh default extract); set to IBERIA_BBOX if you
 *  serve only the bundled Iberia stub, or widen it to match a custom extract. */
export const SUPPORTED_BBOX: [number, number, number, number] = [-31.0, 34.0, 45.0, 72.0];

/** True when (lat, lng) is inside the served basemap extent (see SUPPORTED_BBOX). */
export function inSupportedRegion(lat: number, lng: number): boolean {
  const [w, s, e, n] = SUPPORTED_BBOX;
  return lng >= w && lng <= e && lat >= s && lat <= n;
}

export const SOURCE_LAYERS = {
  water: "water",
  land: "landcover",
  road: "transportation",
  contour: "contour",
  place: "place",
} as const;

/** Default tiles URL: the go-pmtiles container in compose (D1 sets the public origin).
 *  `basemap.pmtiles` is a region-neutral name — the archive may hold any extract
 *  (Iberia, Europe, US, …); the filename is just a convention, see deploy/compose/TILES.md. */
export const DEFAULT_TILES_URL = "pmtiles://http://pmtiles:8080/basemap.pmtiles";
export const VECTOR_SOURCE_ID = "basemap";
